<div class="mainContainer d-flex my-3 mx-3 wrap">
  <div class="text-center">
    <h2 class="headingBL text-nowrap mb-3">
      Virsa The Digital<span> Learning</span>
    </h2>
    <p class="detailText vtext">
      Virsa is your gateway to the world of performing arts. We seamlessly
      connect learners with seasoned instructors, fostering cultural traditions
      in a modern context. Explore your cultural heritage and nurture your
      artistic talents with us. Embrace the legacy of your roots and enrich your
      artistic journey through Virsa's accessible platform.
    </p>
  </div>
  <img
    loading="lazy"
    class="hero_illustration_img"
    src="https://d2abnqj5vuy2s4.cloudfront.net/assets/images/homepage/Intro_Illustration.svg"
    alt="hero_illustration"
  />
</div>
